const tabsEl = document.querySelector('.js-tabs')

if (tabsEl) {
  tabsEl.querySelectorAll('.js-tabs-title').forEach((el) => el.addEventListener('click', () => {
    const name = el.dataset.tab
    const tabsContent = tabsEl.querySelector(`.js-tabs-content[data-tab=${name}]`)
    const tabsTitle = tabsEl.querySelector(`.js-tabs-title[data-tab=${name}]`)
    if (!tabsContent.classList.contains('js-active')) {
      const tabsActiveContent = tabsEl.querySelector('.js-tabs-content.js-active')
      const tabsActiveTitle = tabsEl.querySelector('.js-tabs-title.js-active')
      tabsActiveContent.classList.remove('js-active')
      tabsContent.classList.add('js-active')
      tabsActiveTitle.classList.remove('js-active')
      tabsTitle.classList.add('js-active')
    }
  }))
}

const profilesEl = document.querySelector('.js-profile')

if (profilesEl) {
  profilesEl.querySelectorAll('.js-profile-title').forEach(e => e.addEventListener('click', () => {
    const name = e.dataset.tab
    const profileContent = profilesEl.querySelector(`.js-profile-content[data-tab=${name}]`)
    if (!profileContent.classList.contains('js-active')) {
      const activeProfileContent = profilesEl.querySelector('.js-profile-content.js-active')
      profilesEl.querySelector('.user-menu__client').classList.toggle('active')
      profilesEl.querySelector('.user-menu__partner').classList.toggle('active')
      activeProfileContent.classList.remove('js-active')
      profileContent.classList.add('js-active')
    }
  }))
}


